import {
    COLLECT_MOTOR_INSURANCE_QUOTE_FORM_DATA,
    // COLLECT_NA_THIRD_PARTY_DATA,
    // TRIGGER_CALCULATE_MOTORCYCLE_PREMIUM,
    TRIGGER_GET_ALL_CAR_MAKES,
    TRIGGER_GET_ALL_CAR_MODELS,
    TRIGGER_GET_VALUERS,
} from '../../../actions/naMotorInsurance/quote';
import { COLLECT_CAR_DETAILS_FORM_DATA } from '../../../actions/naMotorInsurance/carDetails';
import { LEADS_SEND_ACTION, TRIGGER_GET_NATIONALITIES } from '../../../actions/naMotorInsurance/personalDetails';

import {
    TRIGGER_NA_PAYMENTS_STK_PUSH,
    CHECK_PAYMENTS_STATUS,
    TRIGGER_CONFIRM_ORDER,
} from '../../../actions/naMotorInsurance/payments';
import { paymentsStkService, paymentsStkStatusService } from './payments';
import { orderConfirmationService } from './orderConfirmation';
import { leadsService } from './leadsEmail';

import { premiumCalculationService } from './premiumCalculation';
import { thirdPartyPremiumCalculationService } from './thirdPartyPremiumCalculation';
import { checkDoubleInsuranceService } from './doubleInsuranceCheck';
import { motorcyclePremiumCalculationService } from './motorCyclePremium';
import { COLLECT_LOGIN_DETAILS } from '../../../actions/naMotorInsurance/auth';
import { loginService } from '../ugMotorInsurance/login';

import { TRIGGER_FETCH_AGENTS } from '../../../actions/naMotorInsurance/motorAgentModal';
import { getAgentsService } from './agents';
import { getValuersService } from './valuers';
import { getCarMakesService } from './carMake';
import { getCarModelsService } from './carModels';
import { getNationalityService } from './nationalities';

export const naMotorInsuranceCover = (store, next, action) => {
    if (action.type.startsWith(TRIGGER_NA_PAYMENTS_STK_PUSH)) {
        return paymentsStkService(store, next, action);
    }
    if (action.type.startsWith(CHECK_PAYMENTS_STATUS)) {
        return paymentsStkStatusService(store, next, action);
    }
    if (action.type.startsWith(COLLECT_MOTOR_INSURANCE_QUOTE_FORM_DATA)) {
        return premiumCalculationService(store, next, action);
    }

    if (action.type.startsWith(COLLECT_CAR_DETAILS_FORM_DATA)) {
        return checkDoubleInsuranceService(store, next, action);
    }

    if (action.type.startsWith(TRIGGER_CONFIRM_ORDER)) {
        return orderConfirmationService(store, next, action);
    }

    if (action.type.startsWith(TRIGGER_GET_ALL_CAR_MAKES)) {
        return getCarMakesService(store, next, action);
    }

    if (action.type.startsWith(COLLECT_LOGIN_DETAILS)) {
        return loginService(store, next, action);
    }

    if (action.type.startsWith(TRIGGER_GET_ALL_CAR_MODELS)) {
        return getCarModelsService(store, next, action);
    }

    if (action.type.startsWith(TRIGGER_FETCH_AGENTS)) {
        return getAgentsService(store, next, action);
    }

    if (action.type.startsWith(TRIGGER_GET_VALUERS)) {
        return getValuersService(store, next, action);
    }

    if (action.type.startsWith(TRIGGER_GET_NATIONALITIES)) {
        return getNationalityService(store, next, action);
    }

    if (action.type.startsWith(LEADS_SEND_ACTION)) {
        return leadsService(store, next, action);
    }

    return null;
};
